
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';
import { Link } from "react-router-dom";

import spanyol from "../../assets/spanyol.png"
import magyar from "../../assets/magyar.png"
import arrow from "../../assets/arrow.png"

function MagyarSpanyol({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Magyar spanyol fordító</title>
                <meta name='description' content="Ingyenes magyar spanyol fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Magyar spanyol fordító" />
                <link rel="canonical" href="https://online-fordito.hu/magyar-spanyol-fordito" />
            </Helmet>
            <h1>Magyar spanyol fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>


                <div className="sectionhead">
                    <h2>A magyar és spanyol nyelv </h2>
                    <img src={magyar} alt="magyar zászló"></img>
                    <img src={spanyol} alt="spanyol zászló"></img>
                </div>


                <p>A magyar az ugor-altaikus nyelvcsaládba, míg a spanyol az indoeurópai nyelvcsaládba, a román nyelvek csoportjába tartozik.</p>

                <h3>Hasonlóságok</h3>
                <ul>
                    <li><b>Hangrendszerek</b>: Mind a magyar, mind a spanyol nyelv rendelkezik hangrendszerekkel. Mindkét nyelvben megkülönböztetjük a magas és mély hangrendeket.</li>

                    <li><b>Ragozás</b>: A magyar és a spanyol nyelv gazdag ragozású nyelvek. Mindkét nyelvben a szavaknak többféle alakja van a különböző esetekben, számokban vagy névmódokban.</li>

                    <li><b>Szórend</b>: Általában mind a magyar, mind a spanyol nyelvben az alany-állítmány-tárgy (AAT) szórend a leggyakoribb, bár mindkét nyelvben lehetnek eltérések és kivételek.</li>

                    <li><b>Szókincs</b>: Bár a magyar és a spanyol nyelvnek eltérő szókincse van, vannak közös szavak és kifejezések is, amelyek azonos vagy hasonló jelentéssel rendelkeznek, különösen azon a területen, ahol a két nyelv történelmileg közel került egymáshoz.</li>
                </ul>


                <h3>Különbségek</h3>
                <ul>
                    <li><b>Nyelvcsalád és rokonság</b>: A magyar ugor-altaikus nyelvcsaládba tartozik, míg a spanyol indoeurópai nyelvcsaládba. Ez azt jelenti, hogy a két nyelvnek eltérő eredete és nyelvtörténete van.</li>

                    <li><b>Hangzások és kiejtés</b>: A magyar és a spanyol nyelvnek eltérő hangzásai és fonetikai rendszerei vannak. Az egyes hangok és a kiejtési szabályok is különböznek a két nyelvben.</li>

                    <li><b>Nyelvtani struktúra</b>: A magyar és a spanyol nyelv nyelvtani struktúrája is eltérő. A spanyol nyelvben más jelzőragok, névmások és igék használata lehet, mint a magyar nyelvben.</li>

                    <li><b>Írásrendszer</b>: A magyar nyelv latin betűs írásrendszert használ, míg a spanyol nyelvben is használnak latin betűket, de a spanyol ábécé tartalmaz néhány különleges karaktert és betűt.</li>
                </ul>
                <div className="sectionbottom">
                    <Link to="/spanyol-magyar-fordito">Spanyol magyar fordító</Link>
                    <img src={spanyol} alt="spanyol zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>
                </div>
            </section>
        </>

    )
}

export default MagyarSpanyol;